
import { AfterContentChecked, ChangeDetectorRef, Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
//import { Hub, HubManager } from 'src/app/pages/hubs/common/Hubs';
import { TmQueueService } from '@app/_core/services/tm-queue.service';

let callInProgress = false,
	callIsConnected = false,
	callEnded = false,
	interactionService, userService, regService, dataService,
	userInfoController, scoringController, surveyController, casesController, appointmentController, newUserController, callFailureController, tabController,
	callersView,
	postCallTimeoutAlert, postCallTimeoutText, requestMoreTimeBtn,
	dialerBypassed = false,
	customTYLanguage = null, numberCalled = null,
	firstName = null,
	lastName = null,
	phoneNumberType,
	saveToUserRecord,
	validationRules,
	inbound = false,
	autoCall = false,
	redial = false,
	newUser = false,
	newUserNumber = null,
	conference = false,
	transfer = false,
	callSid = null,
	queueID = null,
	userID = null,
	isUnknownUser = false,
	primaryCaseID = null,
	interactionID = null,
	scheduledInteractionID = null,
	actionItemID = null,
	actionItem = null,
	queueName = null,
	onHold = false,
	spokesClient = null,
	dialerType = "Manual",
	chatClient = "Twilio",
	chatIdentity = null,
	phoneClient = 'Twilio',//cls.QBRSecurity().GetDefaultPhoneClient(),//ONV-1218- Code changes done by 288293(Sadhesh)
	waitingForCallToComplete = false,
	waitingPrompt = null,
	showInternalTransfer = true,
	showGroupTransfer = false,
	showSkillTransfer = false,
	externalNumbersByQueue = {},
	externalNumbersRetrieved = false,
	externalNumberCallbacks = [],
	callers = null,
	autoAdvanceEnabled = true,
	followUpRequired = false,
	enterRecord = null,
	redialAlert = null,
	lastqueue = null,
	postCallTimeout = 0,
	postCallTimeoutRemaining = 0,
	postCallTimeoutInterval = null,
	storeInboundNumber = true,
	caseUserRoleID = -1,
	jobRole = null,
	sectionsHaveLoaded = false,
	pendingUpdateData = null,
	requireUserOnInbound = true,
	autoSearchByPhone = true,
	autoSearchByName = true,
	requestType = null,
	requestTypeColor = null,
	postCallIVR = false,
	postCallPromptMode = "always",
	confirmingIdentity = false,
	userSelector = null,
	findUserView = null,
	dialogStatusHolder = null,
	dialogStatus = null,
	parentCallStatus = null,
	outgoingCallStatus = null,
	refActivityTypeID = null,
	refActivityID = null,
	refActivityShortName = null,
	//cachedDispoRequiresInteraction = {},
	caseID = 0,
	transferCases = null,
	cachedDispoRequiresInteraction = {},
	activityID = null,
	//refActivityShortName = null,
	viewReady = false,
	pendingFailure = null,
	resumeInteraction = false,
	requireNotes = false,
	isRedial = false,
	blended = false,
	enableCaseCreation = true,
	isVoicemailResponse = false,
	voicemailID = null,
	voicemailNumber = null,
	voicemailView = null,
	voicemailTab = null,
	isGroupTransfer = false,
	isHangUpOnAttended = false,
	groupTransferComplete = false,
	prevUserID = null,
	casesData = {},
	groupTransferCheckTimeout = null,
	userDetailsData = undefined, callHistoryData = undefined, offerData = undefined, scriptData = undefined,
	/* CHAT */
	chatService, videoChatView, textChatView, textChatTab,
	addNewBtn, transferBtn, callDurationLabel, holdDurationLabel,
	queueType = null, roomName = null, token = null,
	disconnectTimeout = null,
	interactionType = null,
	interactionFeatures = null,
	statusFailures = 0,
	enableDialManuallyButton = false,
	enablePriorConversationButton = false,
	postCallIVREnabled = false,
	hideNoAnswerNextRecord = false,
	hideSubmitFollowup = false,
	hideExportToExcel = false,
	crmUserID=null,
	historyView = null;

@Injectable({ providedIn: 'root' })
export class Dialog {
	constructor(private tmQueueService: TmQueueService) {




	}
	index = function (mapping) {
		customTYLanguage = null;
		//im.QueueSelectorController.instance(true).closeView();
		//im.QueueController.instance(true).pauseQueueChecks();
		//first, tell the server what ActionItem we're in
		dialerBypassed = false;
		groupTransferComplete = false;
		userID = null;
		interactionID = null;
		statusFailures = 0;
		actionItemID = mapping.id[0];
		this.tmQueueService.setCurrentActionItem(mapping.id[0], false).subscribe(response => {
			//id: mapping.id[0]
		//}, function (response) {
			inbound = response.Inbound;
			autoCall = response.Auto;
			redial = response.Redial;
			conference = response.Conference;
			transfer = false;
			callSid = response.CallSid;
			queueID = response.QueueID;
			userID = response.UserID;
			isUnknownUser = response.UserID == 0;
			primaryCaseID = response.PrimaryCaseID == 0 ? null : response.PrimaryCaseID;
			caseID = 0;
			transferCases = Array.isArray(response.TransferCases) ? response.TransferCases : [];
			queueName = response.QueueName;
			newUser = response.NewUser;
			newUserNumber = response.PhoneNumber;
			dialerType = response.DialerType;
			chatClient = response.ChatService;
			chatIdentity = response.ChatIdentity;
			phoneClient = response.PhoneClient;
			numberCalled = response.PhoneNumber;
			firstName = response.FirstName;
			lastName = response.LastName;
			enterRecord = null;// qbridge.qcentral.common.Utils.convertServerDate(response.EnterRecord);
			lastqueue = response.LastQueue;
			storeInboundNumber = response.StoreCallerNumber;
			caseUserRoleID = response.CaseUserRoleID; // when > -1, displaying cases where the user is in this roleid
			requireUserOnInbound = response.RequireUserOnInbound;
			autoSearchByPhone = response.AutoSearchByPhone;
			autoSearchByName = response.AutoSearchByName;
			requestType = (redial && (response.RequestType == null || response.RequestType == '')) ? requestType : response.RequestType;
			requestTypeColor = (redial && (response.Color == null || response.Color == '')) ? requestTypeColor : response.Color;
			postCallIVR = !!response.PostCallIVR;
			postCallIVREnabled = response.PostCallIVREnabled;
			postCallPromptMode = response.PostCallPromptMode || 'always';
			refActivityTypeID = response.ReferralActivityTypeID;
			refActivityID = response.ReferralActivityID;
			activityID = response.ActivityID;
			refActivityShortName = response.ReferralActivityShortName;
			postCallTimeout = response.PostCallTimeOut;
			resumeInteraction = (response.RequestType == null || response.RequestType == '') ? response.ResumeInteraction : response.RequestType.trim().toLowerCase() != "callback" ? response.ResumeInteraction : false;
			showInternalTransfer = response.AllowInternalTransfers;
			showGroupTransfer = response.AllowGroupTransfers;
			showSkillTransfer = response.AllowSkillTransfers;
			requireNotes = response.RequireNotes;
			blended = response.Blended;
			hideNoAnswerNextRecord = response.HideNoAnswerNextRecord;
			hideSubmitFollowup = response.HideSubmitFollowup;
			hideExportToExcel = response.HideExportToExcel;
			isGroupTransfer = response.GroupTransfer === true;
			queueType = response.QueueType;
			interactionType = response.InteractionType;
			interactionFeatures = response.InteractionFeatures;
			disconnectTimeout = (response.ChatDisconnectTimeout == null) ? 5 : response.ChatDisconnectTimeout;
			token = response.Token;
			crmUserID = response.CrmUserID;
			jobRole = response.JobRole;
			scheduledInteractionID = response.ScheduledInteractionID;
			voicemailID = response.VoicemailID;
			isVoicemailResponse = voicemailID != null;
			enableCaseCreation = response.EnableCaseCreation;
			enableDialManuallyButton = response.EnableDialManuallyButton;
			enablePriorConversationButton = response.EnablePriorConversationButton;

			let EnableAICaseNotesTemplate = response.Response.Data?.EnableAICaseNotesTemplate || false;
      		this.appService.setEnableTemplateButton(EnableAICaseNotesTemplate);
			//if (viewReady) {
			//	cls.view().requestTypeColor(requestTypeColor);
			//	if (requestType) {
			//		cls.view().requestType(requestType);
			//	} else if (requestType == null) {
			//		cls.view().requestType('');
			//	}
			//}

			//if (response.CrmUserID && userInfoController)
			//	userInfoController.setCrmUserID(response.CrmUserID, inbound, autoSearchByName, jobRole);

			//if (resumeInteraction)
			//	cls.cl().main().mainController().lockStatus({ label: 'Post-Call', value: 8 });
			//else if (!inbound)
			//	cls.cl().main().mainController().lockStatus({ label: 'Pre-Call', value: 7 });

			//if (userID > -1 && cls.view())
			//	cls.view().enableExport();

			//cls.cl().main().mainController().setQueueInfo(queueName, queueID, dialerType, phoneClient, false, interactionType);
			//if (inbound || blended || isVoicemailResponse)
			//	cls.cl().main().mainController().showInboundStatus(true, queueID);
			//else
			//	cls.cl().main().mainController().showOutboundStatus(true);

			if (!inbound && !newUser) {
				//add params to getUser() so it keeps the record locked
				//cls.QBRSecurity().setServerSyncProp('RecordLock', mapping.id[0]);
				//im.TMHub.instance().callServerMethod("lockRecord", [cls.QBRSecurity().clientAbbr(), mapping.id[0], cls.Security().user().UserID]);
			}
			//then render this controller
			//cls.superclass().index.call(cls, mapping, function () {
				//if (userInfoController)
				//	userInfoController.setNewUser(newUser);
				//cls.view().inbound(inbound, hideNoAnswerNextRecord, hideSubmitFollowup);
				var preCheckIVR = (postCallPromptMode == 'opt-out' && postCallIVREnabled != false) || postCallIVREnabled == true;
				//cls.view().showPostCallIVRCheckbox(postCallIVR && postCallPromptMode != 'always', preCheckIVR);

				//cls.view().SetButtonRightValues(enableDialManuallyButton, enablePriorConversationButton);

				//if this is a predictive or automated inbound queue, but we didn't get a call, then wait for the next call
			if (autoCall && !redial && !resumeInteraction && callSid == null) {
				//if (cls.cl().main().mainController().userHasBeenWarned() || dialerType == "AutomatedInbound")
					//cls.cl().main().mainController().waitForCall();
				//else
				//	cls.cl().main().mainController().showAutomationWarning(cls.cl().main().mainController().waitForCall);
				//return;
			}
			else {
				//startVideoRecording();

				//finally, update the data
				//cls.updateData(mapping.id[0], resumeInteraction, resumeInteraction);
				//cls.view().requestTypeColor(requestTypeColor);
				//if (requestType)
				//	cls.view().requestType(requestType);

				//if (autoCall && !redial && !resumeInteraction) {
				//	callInProgress = true;
				//	cls.cl().main().mainController().callStarted({
				//		number: numberCalled,
				//		contact: (typeof userDetailsData != 'undefined' && userDetailsData != null && userDetailsData.hasOwnProperty('FullName')) ? userDetailsData.FullName : null,
				//		inbound: inbound,
				//		pendingTransfer: isGroupTransfer && !groupTransferComplete,
				//		interactionType: interactionType
				//	});
				//	callEnded = false;
				//	callFailureController.hide();
				//	cls.view().callStarted(cls.cl().main().mainController().softPhone());
				//	callConnected();
				//	checkCallStatus();
				//	if (isGroupTransfer)
				//		checkGroupTransferStatus();
				//} else if (resumeInteraction) {
				//	loadUserInfo();
				//}

				//if (autoCall) {
				//	initChatAndVoicemail(chatClient, chatIdentity, inbound, interactionType, token, callSid, interactionFeatures, resumeInteraction, disconnectTimeout, isVoicemailResponse, voicemailID);
				//}
				//});

				//gets the external numbers for the current queue, if we haven't done so already
				//if (!externalNumbersByQueue.hasOwnProperty(queueID)) {
				//	externalNumbersRetrieved = false;
				//	interactionService.GetExternalNumbersByActivity({ queueID: queueID }, function (_externalNumbers) {
				//		externalNumbersRetrieved = true;
				//		externalNumbersByQueue[queueID] = _externalNumbers || [];
				//		//if we have callbacks waiting for external number data, send it to them now
				//		if (externalNumberCallbacks.length > 0) {
				//			for (var x = 0, y = externalNumberCallbacks.length; x < y; x++) {
				//				externalNumberCallbacks[x](_externalNumbers);
				//			}
				//		}
				//	});
				//}
            }
				


		}, function (errorCode, message) {
			//var alert = new a5.cl.ui.modals.UIAlert(),
			//	automated = dialerType == "Preview" || dialerType == "Power" || dialerType == "Progressive" || dialerType == "Predictive" || dialerType == "AutomatedInbound";
			//alert.open("<p>" + message + "</p><p>Press OK to " + (automated ? "go to the next record." : "return to the queue and choose a different record.") + "</p>", function () {
			//	goToNextCall();
			//});
		});

	}
}